<template>
<div class="row" v-if="stats.snapshot">
    <div class="col">
        <h3>{{ stats.snapshot.ourMsol.toFixed(1) }}</h3>
        <h4 class="text-uppercase text-muted">Current mSOL Votes</h4>
    </div>
    <div class="col">
        <h3>
        {{ stats.snapshot.ourMsolEstimate.toFixed() }}</h3>
        <h4 class="text-uppercase text-muted">Estimated Directed Stake</h4>
    </div>
    <div class="col">
        <h3>
            {{ (((1+(stats.snapshot.estimatedAPR + stats.snapshot.marinadeMetrics.msol_price_apy_30d/100)/158)**158 -1)*100).toFixed(2) }}%
        </h3>
        <h4 class="text-uppercase text-muted">Estimated APY</h4>
    </div>
    <div class="col">
        <h3>{{ ((((1+(stats.snapshot.estimatedAPR + stats.snapshot.marinadeMetrics.msol_price_apy_30d/100)/158)**158 -1)*100).toFixed(2)/stats.snapshot.marinadeMetrics.msol_price_apy_30d).toFixed(2) }}x</h3>
        <h4 class="text-uppercase text-muted">Marinade APY Multiplier</h4>
    </div>

    <div class="col-12 text-center small">Stats update every 24 hrs</div>


    <div class="justify-content-center" v-if="this.wallet.publicKey">
        <h4 class="mt-5">Your wallet status</h4>
        <div class="row my-3">
            <div class="col">
                <div class="alert alert-success" v-if="voteRecord==='EARNynHRWg6GfyJCmrrizcZxARB3HVzcaasvNa8kBS72'">Your wallet is voting for Compass</div>
                <div class="alert alert-warning" v-else>Your wallet is not voting for Compass yet</div>
                <h4 class="text-muted text-uppercase">Vote Status</h4>
            </div>
            <div class="col">
                <h3 class="p-2">{{ msolBalance.toFixed(2) }} <small>mSOL</small></h3>
                <h4 class="text-muted text-uppercase">mSOL in wallet now</h4>
            </div>
            <div class="col">
                <h3 class="p-2">{{ Number(snapshot.amount).toFixed(2) }} <small>mSOL</small></h3>

                <h4 class="text-muted text-uppercase">last snapshot (<small>{{ snapshotDate }}</small>)</h4>
            </div>
        </div>

        <h4 class="mt-5">Your staking returns</h4>
        <b-table :items="stats.account"
                 responsive

        :fields="[
            {key:'epoch', label:'Epoch'},
            {key:'snapshot_at', label:'Marinade Snapshot Date'},
            {key:'msol_amount', label:'mSOL Held'},
            {key:'msol_reward', label:'Turbo Staking Reward'},
            {key:'apy_calc', label:'Estimated SOL APY'},
            {key:'paid_at', label:'Date Paid'}
]"
        >
            <template #cell(snapshot_at)="row">
                <div class="small" v-if="row.item.snapshot_at">
                        {{ row.item.snapshot_at }}
                </div>
            </template>
            <template #cell(msol_amount)="row">
                {{ (row.item.msol_amount/1e9).toFixed(4) }} <small>mSOL</small>
            </template>

            <template #cell(msol_reward)="row">
                {{ (row.item.msol_reward/1e9).toFixed(4) }} <small>mSOL</small>
            </template>
            <template #cell(apy_calc)="row">
                {{ (row.item.apy_calc*100).toFixed(2) }}%
            </template>
            <template #cell(paid_at)="row">
                <div class="small" v-if="row.item.paid_at">
                    <a :href="'https://solscan.io/tx/'+row.item.tx_hash" target="_blank">
                        {{ row.item.paid_at }}
                        <img src="/solscan.png" alt="solscan" style="width:16px">
                    </a>
                </div>
            </template>


        </b-table>


        <div class="small text-center">
            Your mSOL held figure is taken from Marinade's snapshot used to calculate stake for each epoch. This snapshot may be some time in advance of the epoch end, and may not always match the most recent daily snapshot shown here. mSOL in wallet now does not include any mSOL in defi that Marinade may track.
        </div>

    </div>
</div>

</template>

<script>
import { useWallet } from 'solana-wallets-vue';

import {Marinade, MarinadeConfig, Wallet, Provider, BN} from '@marinade.finance/marinade-ts-sdk'
import {Connection, PublicKey} from "@solana/web3.js";
// const connection = new Connection("https://solana-mainnet.rpc.extrnode.com", "confirmed");
const connection = new Connection("https://specific-lanny-fast-mainnet.helius-rpc.com/", "confirmed");

const MY_REFERRAL_ACCOUNT = "D9d7WxBeCeNU8zECA4YKG6ciBKHQG5mqmyygCetvXz7H" // <-- your referral account

const config = new MarinadeConfig({
    connection: connection,
    // publicKey: this.wallet.pubKey,
    referralCode: new PublicKey(MY_REFERRAL_ACCOUNT),
})
const marinade = new Marinade(config)


export default {
    name: "TurboStake",
    data() {
        return {
            wallet: useWallet(),
            stats: {},
            marinade: marinade,
            voteRecord: '',
            msolBalance: 0,
            snapshot: {amount:0},
            snapshotDate: '',
        }
    },
    methods: {
        getStats() {
            let url = '/msol_rewards'
            if(this.wallet.connected) {
                url += '?publicKey=' + this.wallet.publicKey
                const config = new MarinadeConfig({
                    connection: connection,
                    publicKey: this.wallet.pubKey,
                    referralCode: new PublicKey(MY_REFERRAL_ACCOUNT),
                })
                this.marinade = new Marinade(config)
                this.getMarinadeStatus()
            }
            axios.get(url).then((response) => {
                this.stats = response.data
            })
            if (this.wallet.connected) {
                this.walletBalance()
                this.getLastSnapshot()
            }

        },
        getMarinadeStatus(){
            this.marinade.getUsersVoteRecord(this.wallet.publicKey).then((response) => {
                console.log(response.voteRecord.account.validatorVote)
                console.log(response.voteRecord.account.validatorVote.toString())
                this.voteRecord = response.voteRecord.account.validatorVote.toString()
            })
            this.marinade.getMarinadeState().then((response) => {
                // console.log(response)
            })

        },
        async getLastSnapshot() {
            axios.get('https://snapshots-api.marinade.finance/v1/votes/msol/latest').then((response) => {
                console.log(response.data)
                let snapshotDate = response.data.mSolSnapshotCreatedAt
                const rtf1 = new Intl.RelativeTimeFormat('en', { style: 'short' });

// Expected output: "in 3 qtrs."
                const d1 = new Date(snapshotDate)
                console.log(d1)
                const d2 = new Date()
                console.log(d2)
                const d3 = d1-d2
                this.snapshotDate = rtf1.format(Math.round(d3/ (60 * 60 * 1000)), 'hours');

                this.snapshot = response.data.records.filter((record) => {
                    return record.tokenOwner === this.wallet.publicKey.toString()
                })[0]
                console.log(this.snapshot, "snapshot")

            })
        },
        async walletBalance() {
            console.log(this.wallet.publicKey)
            let balance = await connection.getBalance(this.wallet.publicKey)
            console.log(balance, "balance")
            this.solBalance = balance / 1e9
            // get msol token balance
            // const msolTokenAccount = await this.marinade.getMSolTokenAccount(this.wallet.publicKey)
            // console.log(msolTokenAccount, "msolTokenAccount")
            // this.msolBalance = msolTokenAccount.amount / 1e9
            const accounts = connection.getParsedTokenAccountsByOwner(
                this.wallet?.publicKey,
                {programId: new PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA')}
            ).then(accounts => {
                let balances = {}
                accounts.value.forEach(account => {
                    const mint = account.account.data.parsed.info.mint
                    balances[mint] = account.account.data.parsed.info.tokenAmount.amount;

                })
                // this.balances = balances
                // console.log(this.balances)
                this.msolBalance = balances['mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'] /1e9 || 0
            })
        },
    },
    watch: {
        "wallet": {
            immediate: true,
            deep: true,
            handler() {
                this.getStats()
            }
        }
    },
}
</script>

<style scoped>

</style>
